module.exports = __webpack_public_path__ + "img/8.50a320c9.jpg";